import React from "react";

import * as classes from "./Navbar.module.css";

export default function Navbar() {
  return (
    <div className={classes.Navbar}>
      <h1>Sudoku Solver</h1>
    </div>
  );
}
